/** Browser-only ChatGPT Ads measurement. The Pixel ID is public configuration. */
type PixelQueue = {
  (...args: unknown[]): void;
  q?: unknown[][];
};

declare global {
  interface Window {
    oaiq?: PixelQueue;
  }
}

// This public ID belongs to the Mindlap landing-page data source in Ads Manager.
// An explicit empty environment override disables measurement for a deployment.
export const openaiPixelId = (process.env.GATSBY_OPENAI_PIXEL_ID ?? 'QkgCnCMwgPyupuo9mm5Qmg').trim();

/** Placed in the server-rendered head so events queue before the SDK loads. */
export const openaiPixelSnippet = openaiPixelId
  ? `(function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var js=d.createElement(s);js.async=true;js.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(js,f)})(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");oaiq("init",{pixelId:${JSON.stringify(openaiPixelId).replace(/</g, '\\u003c')}});`
  : null;

const measure = (name: string, type: 'contents' | 'customer_action'): void => {
  if (!openaiPixelId || typeof window === 'undefined') return;
  try {
    window.oaiq?.('measure', name, { type });
  } catch {
    // Advertising measurement must never interrupt navigation or a signup.
  }
};

export const trackOpenAIPageView = (): void => measure('page_viewed', 'contents');

/** Call only after a form submission succeeds, never on a CTA click. */
export const trackOpenAILead = (): void => measure('lead_created', 'customer_action');
